import React from "react";
import { Row, Col, Form } from "react-bootstrap";
import PersonListRenderer from "./renderers/PersonListRenderer";
import { connect } from "react-redux";

interface AdditionalInformationViewProps
{
    data: AdditionalInformation;
}

class AdditionalInformationView extends React.Component<AdditionalInformationViewProps>
{
    constructor(props: AdditionalInformationViewProps)
    {
        super(props);
    }

    render(): React.ReactNode
    {
        let privacyClass = "";

        if (this.props.settings.length > 0)
            privacyClass = (this.props.role == "academicAdvisor" && this.props.settings.filter(itm => itm.settingId == "psAcademicResearchSupervisor")[0].isActive == true) ? "d-none" : "";

        return <div>
            <h2>Additional</h2>
            {
                this.props.data
                    ?
                    <Form>
                        <Form.Group as={Row}>
                            <Form.Label className="grayText" column md="5">
                                Enrollment Status
                            </Form.Label>
                            <Col md="7">
                                <Form.Control plaintext as={"div"}>
                                    <b>{this.props.data.enrollmentStatus ? this.props.data.enrollmentStatus : " - "}</b>
                                </Form.Control>
                            </Col>
                        </Form.Group>
                        {
                            <div className={privacyClass}>
                                <Form.Group as={Row}>
                                    <Form.Label className="grayText" column md="5">
                                        Research Supervisor
                                    </Form.Label>
                                    <Col md="7">
                                        <Form.Control plaintext as={"div"}>
                                            <PersonListRenderer value={this.props.data.researchSupervisors} />
                                        </Form.Control>
                                    </Col>
                                </Form.Group>
                            </div>
                        }
                        <Form.Group as={Row}>
                            <Form.Label className="grayText" column md="5">
                                Degree Candidate
                            </Form.Label>
                            <Col md="7">
                                <Form.Control plaintext as={"div"}>
                                    <b>{this.props.data.degreeCandidate ? this.props.data.degreeCandidate : " - "}</b>
                                </Form.Control>
                            </Col>
                        </Form.Group>
                    </Form>
                    :
                    <div className="text-center" id='error'>
                        <br />
                        <p className="error-text">No Academic data available</p>
                    </div>
            }
        </div>;
    }
}

const mapStateToProps = (state: any) => ({
    role: state.app.user.role,
    settings: state.app.privacySettings
});

export default connect(mapStateToProps)(AdditionalInformationView);